import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const vanherwerdenApi = createApi({
  reducerPath: 'vanherwerdenApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${window.location.protocol}//${window.location.hostname}`,
    prepareHeaders: (headers) => {
      headers.set('Accept', 'application/json');
      return headers;
    },
  }),
  tagTypes: [
    'productDetail',
    'productImages',
    'productSizes',
    'wishlist',
    'form',
    'sizeGuide',
  ],
  endpoints: (builder) => ({
    getUserSessionInfo: builder.query({
      query: () => 'actions/users/session-info/',
    }),
    getWishlistItems: builder.query({
      query: () => 'actions/frontend/product-overview/wishlist-items/',
      providesTags: ['wishlist'],
    }),
    getProductDetails: builder.query({
      query: (body) => ({
        url: 'actions/frontend/product-details/index/',
        method: 'POST',
        body,
      }),
      providesTags: ['productDetail'],
    }),
    getProductImages: builder.query({
      query: ({ product, color }) => `actions/frontend/product-details/images/?productId=${product}&color=${color}`,
      providesTags: ['productImages'],
    }),
    getForm: builder.query({
      query: (formHandle: string) => `actions/frontend/product-details/form/?formHandle=${formHandle}`,
      providesTags: ['form'],
    }),
    getSizeGuide: builder.query({
      query: ({ guide }) => `actions/frontend/product-details/size-guide/?guide=${guide}`,
      providesTags: ['sizeGuide'],
    }),
    addToCart: builder.mutation({
      query: (body) => ({
        url: 'actions/commerce/cart/update-cart/',
        method: 'POST',
        body,
      }),
    }),
    toggleWishlist: builder.mutation({
      invalidatesTags: ['wishlist'],
      query: (body) => ({
        url: 'actions/wishlist/items/toggle/',
        method: 'POST',
        body,
      }),
    }),
    registerBackInStock: builder.mutation({
      query: (body) => ({
        url: 'actions/craft-commerce-back-in-stock/base/register-interest/',
        method: 'POST',
        body,
      }),
    }),
    submitFormie: builder.mutation({
      query: (body) => ({
        url: 'actions/formie/submissions/submit/',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useGetUserSessionInfoQuery,
  useGetWishlistItemsQuery,
  useGetProductDetailsQuery,
  useGetProductImagesQuery,
  useGetFormQuery,
  useGetSizeGuideQuery,
  useAddToCartMutation,
  useToggleWishlistMutation,
  useRegisterBackInStockMutation,
  useSubmitFormieMutation,
} = vanherwerdenApi;
